import React from 'react'
import { Col, Container, Row } from 'reactstrap'
import ResetPasswordForm from './ResetPasswordForm'

export default function ResetPassword() {
    return (
        <Container className="p-0" fluid>
            <Row className="m-0">
                <Col xs={12} className="p-0">
                    <div className="login-card login-dark">
                        <ResetPasswordForm />
                    </div>
                </Col>
            </Row>
        </Container>
    )
}